import { PureComponent } from "react";

import { BuilderInfoContext } from "helpers/globalContext/BuilderInfoContext";

import { RfiStatus } from "commonComponents/entity/rfi/RfiContainer/RfiContainer.api.types";
import { StatusTagDisplay } from "commonComponents/utilities/Status/StatusTagDisplay";

export interface IRfiStatusTagProps {
    status: RfiStatus;

    testid?: string;
}

const getRfiStatusType = (status: RfiStatus) => {
    switch (status) {
        case RfiStatus.NotReleased:
            return "";
        case RfiStatus.Released:
        case RfiStatus.Reopened:
            return "pending";
        case RfiStatus.Completed:
            return "success";
    }
};

const getRfiStatusText = (status: RfiStatus) => {
    switch (status) {
        case RfiStatus.NotReleased:
            return "Not sent";
        case RfiStatus.Released:
            return "Sent";
        case RfiStatus.Reopened:
            return "Reopened";
        case RfiStatus.Completed:
            return "Complete";
    }
};

export class RfiStatusTag extends PureComponent<IRfiStatusTagProps> {
    static contextType = BuilderInfoContext;
    declare context: React.ContextType<typeof BuilderInfoContext>;

    render() {
        const { status, testid } = this.props;

        return (
            <StatusTagDisplay
                data-testid={testid}
                statusType={getRfiStatusType(status)}
                statusText={getRfiStatusText(status)}
            />
        );
    }
}
